import React from 'react';
import { Grid, List } from 'lucide-react';

const ContentTabsSection = ({ activeTab, setActiveTab, viewMode, setViewMode }) => {
  const tabs = [
    "all",
    "Poetry",          
    "Shayari",
    "Ghazal",
    "Song",
    "Rap",
    "Hip-Hop",
    "Novel",
    "Story",           
    "Book",
    "Script",          
    "Quote",
  ];

  return (
    <div className="border-b border-gray-200 sticky top-0 z-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 py-0">
        <div className="flex items-center justify-between">
          
          {/* Mobile: Horizontal Scrollable Tabs (< 768px) */}
          <div className="flex-1 md:hidden overflow-x-auto scrollbar-hide -mx-4 px-4">
            <div className="flex gap-0 min-w-max">
              {tabs.map((tab) => (
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className={`
                    px-4 py-3 text-sm font-medium transition-all duration-200
                    whitespace-nowrap flex-shrink-0 border-b-2
                    ${activeTab === tab
                      ? "border-black text-black"
                      : "border-transparent text-gray-400 hover:text-gray-600 hover:border-gray-300"
                    }
                  `}
                >
                  {tab.toUpperCase()}
                </button>
              ))}
            </div>
          </div>

          {/* Desktop: Grid Layout (>= 768px) */}
          <div className="hidden md:flex items-center flex-1 min-w-0 -mx-4">
            <div className="flex gap-0 overflow-x-auto scrollbar-hide w-full">
              {tabs.map((tab) => (
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className={`
                    px-6 py-3 text-sm font-medium transition-all duration-200 text-center
                    whitespace-nowrap border-b-2 flex-shrink-0
                    ${activeTab === tab
                      ? "border-black text-black"
                      : "border-transparent text-gray-400 hover:text-gray-600 hover:border-gray-300"
                    }
                  `}
                >
                  {tab.toUpperCase()}
                </button>
              ))}
            </div>
          </div>

          {/* View Mode Toggle */}
          {setViewMode && (
            <div className="flex items-center ml-6 flex-shrink-0">
              <div className="flex items-center gap-4">
                <button
                  onClick={() => setViewMode("grid")}
                  className={`
                    p-0 transition-colors
                    ${viewMode === "grid" 
                      ? "text-black" 
                      : "text-gray-300 hover:text-gray-500"
                    }
                  `}
                  aria-label="Grid view"
                >
                  <Grid className="w-6 h-6" strokeWidth={viewMode === "grid" ? 2 : 1.5} />
                </button>
                <button
                  onClick={() => setViewMode("list")}
                  className={`
                    p-0 transition-colors
                    ${viewMode === "list" 
                      ? "text-black" 
                      : "text-gray-300 hover:text-gray-500"
                    }
                  `}
                  aria-label="List view"
                >
                  <List className="w-6 h-6" strokeWidth={viewMode === "list" ? 2 : 1.5} />
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Custom CSS for hiding scrollbar */}
      <style jsx>{`
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </div>
  );
};

export default ContentTabsSection;